import {snapLayer} from "@/http/services/http-services-snap";
import {transform, transformExtent} from "ol/proj";
import {getLatLonProjectionName, getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {appendDrawCoordinates, undoDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {Point} from "ol/geom";
import {getValueBySelector, hideElementsBySelector} from "@/helpers/element-helper";
import {getBookmarkPresentationsByID, refreshAllActiveLayers} from "@/helpers/ol/ol-layer-helper";
import {showNotification} from "@/helpers/notification-helper";
import {disableMoveLayer} from "@/helpers/ol/map/ol-move-helper.js";

export function snapWmsLayer(coordinate, pixel) {

    const bookmarkPresentationID = getSnapValue()

    // No snap layer selected
    if(!bookmarkPresentationID) {
        return
    }

    const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)

    const destinationProjection = 'EPSG:28992'

    const result = transform([coordinate[0], coordinate[1]], getViewProjectionName(), destinationProjection)
    const size = window.map.getSize()
    const extent = new transformExtent(window.map.getView().calculateExtent(map.getSize()), getViewProjectionName(), destinationProjection)

    const data = {}
    data.width = size[0]
    data.height = size[1]

    data.I = Math.round(pixel[0])
    data.J = Math.round(pixel[1])

    data.x = result[0]
    data.y = result[1]
    if (destinationProjection === getLatLonProjectionName()) {
        data.extent = extent[1] + ',' + extent[0] + ',' + extent[3] + ',' + extent[2]
    } else {
        data.extent = extent.join(',')
    }

    data.info_objects = [{
       domainID: bookmarkPresentation.DomainID,
       presentation: bookmarkPresentation.PresentationID
    }]

    snapLayer(data).then((response) => {
        return response.json()
    }).then((result) => {
        if(result) {
            undoDrawGeometry()
            const coordinates = transform(result, destinationProjection, getViewProjectionName())
            appendDrawCoordinates(coordinates)
        } else {
            showNotification('Geen resultaat gevonden', '', 'warning')
        }
    })
}

function getSnapValue() {

    let value = getValueBySelector('#slcMutationSnapLayer')

    if(!value) {
        value = getValueBySelector('#slcDrawSnapLayer')
    }

    return value
}
